import styled from "styled-components"
import { H1, H2, H3 } from "../Headings"
import theme from "../Theme"
import { Link } from "react-router-dom"

export const PrimaryHeading = H1.extend`
  text-transform: ${props => props.theme.modalHeadingTextTransform};
  color: ${props => props.theme.primary};
  font-size: 1.75rem;
  font-weight: 300;
`

PrimaryHeading.defaultProps = { theme }

export const SubHeading = H2.extend`
  text-transform: ${props => props.theme.modalHeadingTextTransform};
  color: ${props => props.theme.accent};
  font-size: 1rem;
  font-weight: 300;
`
SubHeading.defaultProps = { theme }

export const TrailingHeading = H3.extend`
  color: #fff;
  font-weight: 800;
  font-size: 1rem;
  text-align: center;
  margin: 0 0 0.5rem 0;
  display: block;
`

export const Modal = styled.div`
  flex-align: center;
  max-width: 36rem;
  min-width: 20rem;
  position: relative;
`

Modal.defaultProps = { theme }

export const Header = styled.div`
  padding: ${props => props.theme.modalSectionPadding};
  border-bottom: 1px solid #e5ebf0;
`

Header.defaultProps = { theme }

export const Footer = styled.div`
  padding: ${props => props.theme.modalSectionPadding};
  border-top: 1px solid #e5ebf0;
`

Footer.defaultProps = { theme }

export const Body = styled.div`
  padding: 0;
  background: #fff;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.5);
`

Body.defaultProps = { theme }

export const Content = styled.div`
  padding: ${props => props.theme.modalSectionPadding};
`

Content.defaultProps = { theme }

export const Trailing = styled.div`
  padding: ${props => props.theme.modalSectionPadding};
  background: rgba(9, 42, 68, 0.74);
  margin-top: 1.5rem;
`

Trailing.defaultProps = { theme }

export const Container = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  min-height: 100%;
  min-width: 100%;
  align-items: center;
  display: flex;
  justify-content: center;
  z-index: 10;
`

export const Fade = Container.extend`
  z-index: -1;
  background: ${props =>
    props.dark ? "rgba(0,0,0,0.5)" : "rgba(255,255,255,0.5)"};
`

Container.defaultProps = { theme }

export const FooterLink = styled(Link)`
  color: ${props => props.theme.accent};
  display: block;
  text-align: center;
`



// WEBPACK FOOTER //
// ./src/UI/Modal/index.js